export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'riju',
    name: '日韩剧集',
    description: '最新日韩电视剧中文字幕资源，涵盖恋爱、悬疑、职场、古装等各类题材',
    icon: 'ri-tv-line',
    articleCount: 128,
  },
  {
    slug: 'dianying',
    name: '日韩电影',
    description: '日韩电影中文字幕，从院线大片到独立佳作，一网打尽',
    icon: 'ri-film-line',
    articleCount: 96,
  },
  {
    slug: 'zongyi',
    name: '日韩综艺',
    description: '热门日韩综艺节目中文字幕，搞笑、音乐、旅行、美食应有尽有',
    icon: 'ri-live-line',
    articleCount: 74,
  },
  {
    slug: 'fanju',
    name: '日韩番剧',
    description: '日韩动漫番剧中文字幕资源，新番速递与经典回顾',
    icon: 'ri-ancient-gate-line',
    articleCount: 156,
  },
  {
    slug: 'zuixin',
    name: '最新更新',
    description: '实时更新的最新日韩影视中文字幕资源，紧跟播出进度',
    icon: 'ri-flashlight-line',
    articleCount: 42,
  },
  {
    slug: 'jiaocheng',
    name: '使用教程',
    description: '字幕下载、加载、同步等实用教程，新手也能轻松上手',
    icon: 'ri-book-open-line',
    articleCount: 35,
  },
];